<template>
  <b-select
    :placeholder="$t('Idioma')"
    class="cornered language-selector"
    :value="locale"
    @input="updateLocale"
    size="is-small"
    expanded
  >
    <option key="es" value="es">ES</option>
    <option key="en" value="en">EN</option>
    <option key="cn" value="cn">CN</option>
    <option key="fr" value="fr">FR</option>
    <option key="ar" value="ar">عربى</option>
    <option key="pt" value="pt">PT</option>
  </b-select>
</template>

<script>
import { localize } from 'vee-validate'

export default {
  name: 'LanguageSelector',
  components: {},
  data() {
    return {
      locale: this.$i18n.locale
    }
  },
  computed: {},
  mounted() {},
  methods: {
    updateLocale(val) {
      let self = this
      localStorage.setItem('locale', val)
      self.$i18n.locale = val
      localize(val)
      self.$dialog.confirm({
        message: self.$t(
          'Para que se realice completamente el cambio de idioma es necesario recargar la página, ¿Desea hacerlo ahora?'
        ),
        type: 'is-danger',
        onConfirm: function() {
          location.reload()
        }
      })
    }
  }
}
</script>

<style lang="scss">
.language-selector {
  margin: auto;
  &.cornered select {
    color: #777777 !important;
    border: none !important;
    padding-right: 30px;
  }
  &.cornered select,
  .select:not(.is-multiple):not(.is-loading)::after {
  }
}
</style>
